
import Vue from "vue";
import Component from "vue-class-component";

const NoCampsProps = Vue.extend({});

@Component({})
export default class NoCamps extends NoCampsProps {}
